export const calculateBase64Size = (stringSize) => Math.floor(stringSize / 3) * 4 + (stringSize % 3 > 0 ? 4 : 0);
